import React from 'react';
import '../../pages/Animation.css';

const Loader = () => {
  return (
    <div className="global-loader-overlay">
      <div className="bubbles-wrapper">
        <div className="bubble bubble-large bubble-1"></div>
        <div className="bubble bubble-medium bubble-2"></div>
        <div className="bubble bubble-small bubble-3"></div>
        <div className="bubble bubble-large bubble-4"></div>
        <div className="bubble bubble-medium bubble-5"></div>
        <div className="bubble bubble-small bubble-6"></div>
      </div>
      <div className="loader-text">Ładowanie...</div>
    </div>
  );
};

export default Loader;
